/**
 * `PuhettapalkastaRoute` — slug-pinned re-export of `ArticleDetailPage`
 * for the `/puhetta-palkasta` proto-equivalent URL (TA21).
 *
 * Clean-lift article (no bespoke chrome). See
 * `TyosuhteenPaattaminenRoute.tsx` for the file-header rationale shared
 * by all three TA21 re-exports.
 */

import type { JSX } from 'react';

import { ArticleDetailPage } from './ArticleDetailPage.js';

export function PuhettapalkastaRoute(): JSX.Element {
  return (
    <ArticleDetailPage
      slug="puhetta-palkasta"
      analyticsPageKey={{ kind: 'memberRoute', route: 'salary-discussion' }}
    />
  );
}
